<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("ticketpriceconfiguration") }}
      </div>
      <router-link class="btn-blue" to="ticket-price-configurations"
        >{{ $t("ticketpriceconfiguration") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="add-movie-container">
      <form class="row">
        <!-- Cinemas -->
        <div class="col-md-6 mb-4">
          <div class>
            <!-- <label>{{ $tc("cinema", 2) }}</label> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown
              :text="selectedCinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in Cinemas"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <Tooltip :title="$t('ticketPriceConfiguration_cinemas')" /> -->
          </div>
          <!-- <p class="error_msg">{{ $t('titleempty') }}</p> -->
        </div>

        <!-- Movies -->
        <div class="col-md-6 mb-4">
          <div class>
            <!-- <label>{{ $tc("movie", 1) }}</label> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown
              :text="selectedMovie"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Movie, MovieIndex) in Movies"
                v-on:click="onSelectMovie($event, Movie)"
                :key="MovieIndex"
                >{{ Movie.movie }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <Tooltip :title="$t('ticketPriceConfiguration_Movie')" /> -->
          </div>
          <!-- <p class="error_msg">{{ $t('titleempty') }}</p> -->
        </div>

        <!-- Screen -->
        <div class="col-md-6 mb-4">
          <div class>
            <!-- <label>{{ $t("screens") }}</label> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown
              :text="selectedScreen"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in Screens"
                @click="onSelectScreen($event, Screen)"
                :key="ScreenIndex"
                >{{ Screen.screen_name }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <Tooltip :title="$t('ticketPriceConfiguration_Screens')" /> -->
          </div>
          <!-- <p class="error_msg">{{ $t('titleempty') }}</p> -->
        </div>

        <!-- FromDate -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  v-model="SchedulePriceObject.ss_start_date"
                  @selected="onSelectDate($event, 'ss_start_date')"
                  ref="programaticOpen"
                ></Datepicker>
                <label
                  :class="[
                    '',
                    SchedulePriceObject.ss_start_date ? 'active' : '',
                  ]"
                  >{{ $t("fromdate") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('ticketPriceConfiguration_FromDate')" /> -->
          </div>
          <!-- <p class="error_message">{{ $t("blankfieldmsg") }}</p> -->
        </div>

        <!--ToDate -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  v-model="SchedulePriceObject.ss_end_date"
                  @selected="onSelectDate($event, 'ss_end_date')"
                  ref="programaticOpen"
                ></Datepicker>
                <label
                  :class="['', SchedulePriceObject.ss_end_date ? 'active' : '']"
                  >{{ $t("fromdate") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('ticketPriceConfiguration_ToDate')" /> -->
          </div>
          <!-- <p class="error_message">{{ $t("blankfieldmsg") }}</p> -->
        </div>
      </form>

      <div
        class="row"
        v-for="(SchedulePrice, SchedulePriceIndex) in SchedulePriceList"
        :key="SchedulePriceIndex"
      >
        <div class="col-12">
          <div class="row">
            <div
              class="col-4 mb-4"
              v-for="(item, itemIndex) in SchedulePrice.list"
              :key="itemIndex"
            >
              <div v-if="itemIndex == 0">
                <div v-if="SchedulePriceIndex == 0" class="text-center">
                  {{ item.label }}
                </div>
                <div class="input-container mw-auto">
                  <input :value="item.o" disabled type="text" />
                </div>
              </div>
              <div v-if="itemIndex !== 0">
                <div v-if="SchedulePriceIndex == 0" class="text-center">
                  {{ item.label }}
                </div>
                <b-dropdown
                  :text="item.rc_name"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in Ratecards"
                    @click="
                      onSelectRatecard(
                        $event,
                        Ratecard,
                        SchedulePriceIndex,
                        itemIndex
                      )
                    "
                    :key="RatecardIndex"
                    >{{ Ratecard.rc_name }} -
                    {{ Ratecard.rc_total_amount }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="ticket-price-configurations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import moment from "moment";

const SchedulePrice = {
  ss_id: null,
  ss_start_show_time: "",
  sst_seat_type: "",
  sst_id: null,
  rc_id: null,
  rc_name: "",
  currency_id: "",
};

export default {
  data() {
    return {
      // Saif
      Cinemas: [],
      selectedCinema: "Select Cinema",
      Movies: [],
      selectedMovie: "Select Movie",
      Screens: [],
      selectedScreen: "Select Screen",
      SeatTypes: [],
      selectedSeatTypes: "Select Seat Types",
      ScheduleShowTimes: [],
      selectedScheduleShowTime: "Select Time",

      SchedulePriceList: [],
      SchedulePriceObject: {
        currency_id: null,
        cine_id: null,
        screen_id: null,
        md_id: null,
        ss_id: null,
        ss_start_date: null,
        ss_end_date: null,
        p_start_date_time: null,
        p_end_date_time: null,
      },

      Ratecards: [],
      FinalArray: [],
      // Saif
    };
  },
  beforeMount() {
    const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id)
    // this.getCinemaList();
    this.getMoviesList();
    // this._GetGlobalOptions();
    console.log("this.secureStore.set:", this.secureStore.get("BRGLOPCU"));
    this.SchedulePriceObject.currency_id =
      this.secureStore.get("BRGLOPCU") &&
      this.secureStore.get("BRGLOPCU").go_value
        ? this.secureStore.get("BRGLOPCU").go_value
        : null;
  },
  mounted() {},
  methods: {
    // Saif
    onResetForm: function () {
      this.Cinemas = [];
      this.selectedCinema = "Select Cinema";
      this.Movies = [];
      this.selectedMovie = "Select Movie";
      this.Screens = [];
      this.selectedScreen = "Select Screen";
      this.SeatTypes = [];
      this.selectedSeatTypes = "Select Seat Types";
      this.ScheduleShowTimes = [];
      this.selectedScheduleShowTime = "Select Time";
      this.SchedulePriceList = [];
      this.SchedulePriceObject = {
        currency_id: null,
        cine_id: null,
        screen_id: null,
        md_id: null,
        ss_id: null,
        ss_start_date: null,
        ss_end_date: null,
        p_start_date_time: null,
        p_end_date_time: null,
      };
      this.Ratecards = [];

      this.FinalArray = [];
    },

    getCinemaList: function (cinema_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            console.log("this.Cinemas :", this.Cinemas);
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getMoviesList: function () {
      this.Movies = [];
      MovieService.GetActiveMoviesWithFormat()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Movies = data.Records;
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getActiveScreenByCinemaId: function (condition_id) {
      this.Screens = [];
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: condition_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Screens = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getActiveSeatTypeByScreenId: function (condition_id) {
      this.SeatTypes = [];
      if (condition_id) {
        let payload = {
          tableName: "screen_seat_type",
          sst_is_active: "Y",
          screen_id: condition_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.SeatTypes = data.Records;
              this.onMakeSchedulePriceArray();
            } else {
              // Shoe Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      }
    },
    getScheduleShowTimes: function () {
      let payload = {
        cine_id: this.SchedulePriceObject.cine_id,
        movie_details_id: this.SchedulePriceObject.md_id,
        screen_id: this.SchedulePriceObject.screen_id,
        ss_start_date: this.SchedulePriceObject.ss_start_date,
        ss_end_date: this.SchedulePriceObject.ss_end_date,
      };
      CinemasService.GetTicketPriceConfiguration(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ScheduleShowTimes = data.Records;
            console.log("this.ScheduleShowTimes :", this.ScheduleShowTimes);
            this.onMakeSchedulePriceArray();
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log(
            "Catch Error on getTicketPriceConfigurationList :",
            error
          );
        });
    },
    getActiveRatecardByCinemaAndCurrencyId: function () {
      this.Ratecards = [];

      if (
        this.SchedulePriceObject.cine_id &&
        this.SchedulePriceObject.currency_id
      ) {
        let payload = {
          cinema_id: this.SchedulePriceObject.cine_id,
          currency_id: this.SchedulePriceObject.currency_id,
        };
        CinemasService.GetActiveRatecardByCinemaAndCurrencyId(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Ratecards = data.Records;
              console.log("this.Ratecards :", this.Ratecards);
            } else {
              // Show Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log(
              "Catch Error On getActiveRatecardByCinemaAndCurrencyId :",
              error
            );
          });
      }
    },
    onMakeSchedulePriceArray: function () {
      if (this.SeatTypes.length > 0 && this.ScheduleShowTimes.length > 0) {
        this.SchedulePriceList = [];
        this.ScheduleShowTimes.map((x) => {
          let array = [];
          array.push({ label: "Time", ...x });
          this.SeatTypes.map((y) => {
            array.push({
              label: y.sst_seat_type,
              rc_id: null,
              ss_id: x.ss_id,
              rc_name: "Select Ratecard",
              ...y,
            });
          });
          this.SchedulePriceList.push({ list: array });
        });
        console.log("this.SchedulePriceList :", this.SchedulePriceList);
      }
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.SchedulePriceObject.cine_id = params.cine_id;
      this.getActiveScreenByCinemaId(params.cine_id);
      this.getActiveRatecardByCinemaAndCurrencyId();
      this.getScheduleShowTimes();
    },
    onSelectMovie: function (event, params) {
      this.selectedMovie = params.movie;
      this.SchedulePriceObject.md_id = params.md_id;
      this.getScheduleShowTimes();
    },
    onSelectScreen: function (event, params) {
      this.selectedScreen = params.screen_name;
      this.SchedulePriceObject.screen_id = params.screen_id;
      this.getActiveSeatTypeByScreenId(params.screen_id);
      this.getScheduleShowTimes();
    },
    onSelectScheduleShowTime: function (event, params) {
      this.selectedScheduleShowTime = params.ss_start_show_time;
      this.SchedulePriceObject.ss_id = params.ss_id;
    },
    onSelectDate: function (event, key) {
      this.SchedulePriceObject[key] = event;
      this.getScheduleShowTimes();
    },
    onSelectRatecard: function (
      event,
      Ratecard,
      SchedulePriceIndex,
      itemIndex
    ) {
      this.SchedulePriceList[SchedulePriceIndex].list[itemIndex].rc_id =
        Ratecard.rc_id;
      this.SchedulePriceList[SchedulePriceIndex].list[itemIndex].rc_name =
        Ratecard.rc_name + "-" + Ratecard.rc_total_amount;
    },
    getFinalPayload: async function () {
      this.FinalArray = [];
      let Promises = this.SchedulePriceList.map((x, xIndex) => {
        x.list.map((y, yIndex) => {
          if (yIndex !== 0 && y.rc_id) {
            this.FinalArray.push({
              rate_card_id: y.rc_id,
              cinema_id: this.SchedulePriceObject.cine_id,
              screen_id: this.SchedulePriceObject.screen_id,
              md_id: this.SchedulePriceObject.md_id,
              schedule_show_id: y.ss_id,
              screen_seat_type_id: y.sst_id,
              p_start_date_time: this.SchedulePriceObject.p_start_date_time
                ? moment(
                    new Date(this.SchedulePriceObject.p_start_date_time)
                  ).format("YYYY-MM-DD HH:mm:ss")
                : null,
              p_end_date_time: this.SchedulePriceObject.p_end_date_time
                ? moment(
                    new Date(this.SchedulePriceObject.p_end_date_time)
                  ).format("YYYY-MM-DD HH:mm:ss")
                : null,
              p_start_time_timestamp: this.SchedulePriceObject.p_start_date_time
                ? +new Date(this.SchedulePriceObject.p_start_date_time)
                : null || null,
              p_end_time_timestamp: this.SchedulePriceObject.p_end_date_time
                ? +new Date(this.SchedulePriceObject.p_end_date_time)
                : null || null,
              p_is_active: this.SchedulePriceObject.p_start_date_time
                ? "Y"
                : "N",
              created_at: new Date(),
              created_by: 1,
            });
          }
          //
        });
      });
      return await Promise.all(Promises);
    },
    onFinalSubmit: function (redirect) {
      this.getFinalPayload()
        .then((result) => {
          console.log("this.FinalArray :", this.FinalArray);
          let payload = {
            FinalArray: this.FinalArray,
          };
          CinemasService.addTicketPriceConfiguration(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/ticket-price-configurations",
                  });
                }
              }
            })
            .catch((error) => {
              // Catch Error:
              console.log("Catch Error on onFinalSubmit :", error);
            });
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch error on getFinalPayload :", error);
        });
    },
    // Saif
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/addTicketPriceConfiguration.vue